export default __webpack_public_path__ + "static/media/savings-active-icon.ec0bbc87.svg";